import React from 'react';
import { Target, Eye, Heart, ArrowRight, CheckCircle2 } from 'lucide-react';

const NosotrosSection = () => {
    const pillars = [
        {
            icon: <Target size={40} color="#00FFD1" />,
            title: 'MISIÓN',
            description: 'Nuestra razón de ser y el compromiso que renovamos cada día.',
            features: [
                'Brindar soluciones tecnológicas de vanguardia',
                'Garantizar la estabilidad operativa de nuestros clientes',
                'Democratizar el uso de Linux empresarial',
                'Innovación constante en ciberseguridad'
            ]
        },
        {
            icon: <Eye size={40} color="#00FFD1" />,
            title: 'VISIÓN',
            description: 'Hacia dónde nos dirigimos y cómo planeamos transformar el futuro.',
            features: [
                'Ser referentes globales en infraestructura Linux',
                'Liderar la transición a nubes híbridas seguras',
                'Crear un ecosistema digital inmutable',
                'Expansión tecnológica en mercados emergentes'
            ]
        },
        {
            icon: <Heart size={40} color="#00FFD1" />,
            title: 'VALORES',
            description: 'Los principios éticos que rigen cada una de nuestras decisiones.',
            features: [
                'Transparencia total con el cliente',
                'Excelencia técnica y precisión',
                'Compromiso con el código abierto',
                'Resiliencia ante desafíos críticos'
            ]
        }
    ];

    return (
        <section id="nosotros" style={{
            padding: '100px 7.6923%',
            background: '#000000',
            position: 'relative'
        }}>
            {/* Background Grid Pattern */}
            <div className="grid-pattern" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none'
            }} />

            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                position: 'relative',
                zIndex: 2
            }}>
                {/* Section Header */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '80px'
                }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 16px',
                        background: 'rgba(0, 255, 209, 0.1)',
                        borderRadius: '0px',
                        marginBottom: '24px'
                    }}>
                        <span style={{
                            color: '#00FFD1',
                            fontSize: '14px',
                            fontWeight: 500
                        }}>CONÓCENOS</span>
                    </div>
                    <h2 style={{
                        fontSize: '48px',
                        fontWeight: 600,
                        lineHeight: 1.1,
                        color: '#FFFFFF',
                        marginBottom: '20px'
                    }}>
                        Nuestra Esencia
                    </h2>
                    <p style={{
                        fontSize: '20px',
                        color: 'rgba(255, 255, 255, 0.85)',
                        maxWidth: '700px',
                        margin: '0 auto'
                    }}>
                        En PIXELINUX, no solo construimos software; forjamos la base sólida para el futuro de tu empresa.
                    </p>
                </div>

                {/* Pillars Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                    gap: '40px'
                }} className="nosotros-grid">
                    {pillars.map((item, index) => (
                        <div
                            key={index}
                            className="dark-hover"
                            style={{
                                background: '#121212',
                                border: '1px solid rgba(255, 255, 255, 0.25)',
                                padding: '40px',
                                transition: 'all 0.4s ease-in-out',
                                cursor: 'pointer'
                            }}
                        >
                            {/* Icon */}
                            <div style={{
                                marginBottom: '24px'
                            }}>
                                {item.icon}
                            </div>

                            {/* Title */}
                            <h3 style={{
                                fontSize: '24px',
                                fontWeight: 600,
                                color: '#FFFFFF',
                                marginBottom: '16px',
                                lineHeight: 1.3
                            }}>
                                {item.title}
                            </h3>

                            {/* Description */}
                            <p style={{
                                fontSize: '16px',
                                color: 'rgba(255, 255, 255, 0.85)',
                                lineHeight: 1.5,
                                marginBottom: '24px'
                            }}>
                                {item.description}
                            </p>

                            {/* List */}
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                margin: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px'
                            }}>
                                {item.features.map((feature, fIndex) => (
                                    <li key={fIndex} style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '8px',
                                        fontSize: '14px',
                                        color: '#4D4D4D'
                                    }}>
                                        <CheckCircle2 size={16} color="#00FFD1" style={{ marginTop: '2px', flexShrink: 0 }} />
                                        <span>{feature}</span>
                                    </li>
                                ))}
                            </ul>

                            {/* Footer de la tarjeta */}
                            <div style={{
                                marginTop: '32px',
                                paddingTop: '24px',
                                borderTop: '1px solid rgba(255, 255, 255, 0.25)'
                            }}>
                                <button
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        color: '#00FFD1',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        transition: 'gap 0.3s ease',
                                        padding: 0
                                    }}
                                >
                                    Saber más
                                    <ArrowRight size={16} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style jsx="true">{`
        @media (max-width: 1024px) {
          .nosotros-grid {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
          }
        }
        @media (max-width: 767px) {
          .nosotros-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
        </section>
    );
};

export default NosotrosSection;